import { DetailsList, IDetailsHeaderProps, IDetailsListProps, ScrollablePane, Sticky } from "@fluentui/react"
import { useEffect, useRef, useState } from "react"

export function StickeyHeaderDetailsList(props: IDetailsListProps) {
	const containerRef = useRef<HTMLDivElement>()
	const [containerHeight, setContainerHeight] = useState<string>()

	const initContainerHeight = () => {
		if (containerRef.current) {
			const containerOffsetTop = containerRef?.current?.getBoundingClientRect()?.top
			const containerOffset = containerOffsetTop ? parseInt(containerOffsetTop.toString()) + 136 : undefined
			setContainerHeight(containerOffset ? `calc(100vh - ${containerOffset}px)` : undefined)
		} else {
			setTimeout(() => {
				initContainerHeight()
			}, 100)
		}
	}

	useEffect(() => {
		initContainerHeight()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const onRenderDetailsHeader = (props?: IDetailsHeaderProps, defaultRender?: (props?: IDetailsHeaderProps) => JSX.Element): JSX.Element => {
		if (!props || !defaultRender) {
			//technically these may be undefined...
			return null
		}
		return (
			<Sticky>
				{defaultRender({
					...props,
					styles: {
						root: {
							marginBottom: 12,
							borderBottom: 0,
							selectors: {
								".ms-DetailsHeader-cell": {
									whiteSpace: "normal",
									textOverflow: "clip",
									lineHeight: "normal"
								},
								".ms-DetailsHeader-cellTitle": {
									height: "100%",
									alignItems: "center"
								}
							}
						}
					}
				})}
			</Sticky>
		)
	}

	return (
		<div>
			<div style={{ position: "relative", height: containerHeight }} ref={containerRef}>
				<ScrollablePane>
					<DetailsList
						onShouldVirtualize={() => false}
						onRenderDetailsHeader={onRenderDetailsHeader}
						{...props}
						focusZoneProps={
							{
								className: "focus-zone",
								"data-is-scrollable": "true"
							} as React.HTMLAttributes<HTMLElement>
						}
					/>
				</ScrollablePane>
			</div>
		</div>
	)
}
